var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDossierReload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 10.25V10.2C21 9.0799 21 8.51984 20.782 8.09202C20.5903 7.7157 20.2843 7.40974 19.908 7.21799C19.4802 7 18.9201 7 17.8 7L3 7M3 7L3 17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.7157 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H7M3 7L3 6.6C3 6.03995 3 5.75992 3.109 5.54601C3.20487 5.35785 3.35785 5.20487 3.54601 5.10899C3.75992 5 4.03995 5 4.6 5H9.33726C9.58185 5 9.70415 5 9.81923 5.02763C9.92127 5.05213 10.0188 5.09253 10.1083 5.14736C10.2092 5.2092 10.2957 5.29568 10.4686 5.46863L12 7",
    stroke: "url(#paint0_linear_1483_164541)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3333 15.6471H18V13M17.8449 20.0714C17.348 20.8311 16.6187 21.4126 15.7643 21.7305C14.9099 22.0485 13.9752 22.0861 13.0976 21.8379C12.22 21.5898 11.4458 21.069 10.8884 20.3519C10.3311 19.6347 10.02 18.759 10.0009 17.8534C9.98183 16.9478 10.2555 16.06 10.7821 15.3203C11.3088 14.5806 12.0605 14.0281 12.9268 13.7437C13.7932 13.4593 14.7286 13.4579 15.5957 13.7401C16.4628 14.0223 17.216 14.5729 17.7446 15.3112",
    stroke: "url(#paint1_linear_1483_164541)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1483_164541",
    x1: 4.2,
    y1: 21,
    x2: 13.6244,
    y2: 2.70721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1483_164541",
    x1: 10.5333,
    y1: 22,
    x2: 16.4907,
    y2: 12.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACE8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossierReload);
export default __webpack_public_path__ + "static/media/DossierReload.0fb99fb353f40dd33590a90b2983982a.svg";
export { ForwardRef as ReactComponent };